// Insights leads because an agency opens this page to find out where to look, not to page through a
// roster they already know. Clients stays one click away for when they have a name.
export const AGENCY_TABS = ['insights', 'clients', 'team'] as const;
export type IAgencyTab = typeof AGENCY_TABS[number];
export const isAgencyTab = (value: string | null | undefined): value is IAgencyTab => AGENCY_TABS.some(tab => tab === value);

export const AGENCY_TAB_LABEL: { [tab in IAgencyTab]: string } = {
    insights: 'Insights',
    clients: 'Clients',
    team: 'Team'
};

export const AGENCY_TAB_PARAM = 'tab';

/** How a caller asks the agency home to open on a tab other than the one it would land on. */
export const agencyTabSearch = (tab: IAgencyTab) => `${AGENCY_TAB_PARAM}=${tab}`;

export const agencyTabPath = (tab: IAgencyTab) => `/caregiver/${tab}`;

export const isAgencyTabPath = (path: string): boolean => AGENCY_TABS.some(tab => path === agencyTabPath(tab));

export const AGENCY_TAB_ROUTE = `/caregiver/:tab(${AGENCY_TABS.join('|')})`;
